import { c as _c } from "react/compiler-runtime";
import imageUrl from "@/sanity/utilities/imageUrl";
import Image from "@/components/common/image/image";
import { ExecFeatureData } from "@/sanity/interfaces";
import SuperTitle from "@/components/common/supertitle/supertitle";
import { PortableText } from "next-sanity";
interface ICeoSectionProps {
  data: ExecFeatureData;
}
const CeoSection = t0 => {
  const $ = _c(24);
  const {
    data
  } = t0;
  const {
    quote,
    person
  } = data;
  if (!quote || !person?.photo?.asset) {
    return null;
  }
  let t1;
  if ($[0] !== person.photo.asset) {
    t1 = imageUrl(person.photo.asset).url();
    $[0] = person.photo.asset;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = person?.name ?? "CEO";
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className="order-2 w-full flex-shrink-0 overflow-hidden md:h-[550px] lg:order-1 lg:w-[40%]"><Image src={t1} alt={t2} width={594} height={464} className="h-full w-full object-cover" /></div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = data?.eyebrow;
  let t5;
  if ($[5] !== t4) {
    t5 = <SuperTitle className="mb-4">{t4}</SuperTitle>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="mb-5"><Image src="/quote-icon.svg" alt="Quote" width={52} height={46} className="h-auto w-[32px] md:w-[52px]" /></div>;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      block: {
        normal: _temp
      },
      marks: {
        highlight: _temp2
      }
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== quote) {
    t8 = <PortableText value={quote} components={t7} />;
    $[9] = quote;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="absolute left-0 top-3 h-[2px] w-8 bg-[#009490]" />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== person.name) {
    t10 = <div className="font-bold text-[#005472]">{person.name}</div>;
    $[12] = person.name;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="text-xs text-[#8D8D8D]">Chief Executive Officer, AmeriSave</div>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10) {
    t12 = <div className="mt-6"><div className="relative">{t9}<div className="pl-12">{t10}{t11}</div></div></div>;
    $[15] = t10;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t12 || $[18] !== t5 || $[19] !== t8) {
    t13 = <div className="relative order-1 flex flex-col text-left lg:order-2 lg:w-[45%]">{t5}{t6}{t8}{t12}</div>;
    $[17] = t12;
    $[18] = t5;
    $[19] = t8;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t3) {
    t14 = <div className="flex flex-col items-start gap-8 bg-[#F5F7F9] px-5 py-10 md:px-14 lg:flex-row lg:items-center lg:gap-[72px]">{t3}{t13}</div>;
    $[21] = t13;
    $[22] = t3;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
};
export default CeoSection;
function _temp(t0) {
  const {
    children
  } = t0;
  return <p className="font-poppins text-2xl font-medium leading-[36px] text-[#00698F] md:text-[32px] md:leading-[38px]">{children}</p>;
}
function _temp2(t0) {
  const {
    children: children_0
  } = t0;
  return <span className="text-[#009490]">{children_0}</span>;
}